module.exports = __webpack_public_path__ + "static/media/arrow-repeat.dc8c73e4.svg";